// extracted by mini-css-extract-plugin
module.exports = {"pageMaxWidth":"950px"};